import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import {
    updateDistrict,
    updateRS,
    updateRssOss,
    updateRssOssType,
    resetSearchBtn,
    setDateRange
} from '../../actions';
import Accordion from '../ui/accordion';
import Datepicker from '../ui/datepicker';
import Select from '../ui/select';
import Checkbox from '../ui/checkbox';

import {
    getRegionCodeList,
    getDistrictCodeList,
    getRecruitingStationCodeList,
    getRssOssCodeList
} from '../../reducers';

const makeSearchData = (
    model,
    updateDistrict,
    updateRS,
    updateRssOss,
    updateRssOssType,
    regionCodeList,
    districtCodeList,
    recruitingStationCodeList,
    rssOssCodeList,
    setDateRange
) => [
    {
        title: 'Region',
        content: (
            <Select
                model={`${model}.regionCode`}
                changeDefault={'National'}
                onChange={updateDistrict}
                options={regionCodeList}
            />
        )
    },
    {
        title: 'District',
        content: (
            <Select
                model={`${model}.districtCode`}
                onChange={updateRS}
                options={districtCodeList}
            />
        )
    },
    {
        title: 'RS',
        content: (
            <Select
                model={`${model}.recruitingStationCode`}
                onChange={updateRssOss}
                options={recruitingStationCodeList}
            />
        )
    },
    {
        title: 'RSS/OSS',
        content: (
            <Select
                model={`${model}.rssOssCode`}
                options={rssOssCodeList}
                onChange={updateRssOssType}
            />
        )
    },
    {
        title: 'Status',
        content: (
            <div className="form__status">
                <Checkbox
                    model={`${model}.eventStatus[]`}
                    options={[
                        { name: 'Event Creation', code: 'Event Creation' },
                        { name: 'Event Review', code: 'Event Review' }
                    ]}
                />
                <Checkbox
                    model={`${model}.eventReportStatus[]`}
                    options={[
                        {
                            name: 'After Action Pending',
                            code: 'After Action Pending'
                        },
                        {
                            name: 'After Action Incomplete',
                            code: 'After Action Incomplete'
                        },
                        {
                            name: 'After Action Review',
                            code: 'After Action Review'
                        },
                        {
                            name: 'Event/After Action Closed',
                            code: 'Event/After Action Closed'
                        }
                    ]}
                />
            </div>
        )
    },
    {
        title: 'Other',
        content: (
            <div>
                <Checkbox
                    model={`${model}.isFromEac[]`}
                    options={[
                        { name: 'Handheld Event', code: 'isFromEac', value: 1 }
                    ]}
                />
                <Checkbox
                    model={`${model}.isFromPr[]`}
                    options={[
                        { name: 'Influencer Event', code: 'isFromPr', value: 1 }
                    ]}
                />
            </div>
        )
    }
];

const mapStateToProps = state => ({
    regionCodeList: getRegionCodeList(state),
    districtCodeList: getDistrictCodeList(state),
    recruitingStationCodeList: getRecruitingStationCodeList(state),
    rssOssCodeList: getRssOssCodeList(state)
});

export default connect(
    mapStateToProps,
    {
        updateDistrict,
        updateRS,
        updateRssOss,
        updateRssOssType,
        resetSearchBtn,
        setDateRange
    }
)(
    ({
        closeOnClick,
        includeDates = false,
        isActive,
        fromDate,
        model,
        showClose = true,
        updateDistrict,
        updateRS,
        updateRssOss,
        updateRssOssType,
        regionCodeList,
        districtCodeList,
        recruitingStationCodeList,
        rssOssCodeList,
        resetSearchBtn,
        setDateRange
    }) => (
        <section
            className={classnames('panel', `panel--${model}`, {
                'is-active': isActive
            })}
        >
            <div className="panel__inner">
                <div className="panel__actions">
                    <h1 className="panel__heading">Filters</h1>
                    {showClose ? (
                        <button
                            onClick={closeOnClick}
                            className="panel__close-btn"
                        >
                            <svg className="icon icon-close">
                                <use xlinkHref="#icon-close" />
                            </svg>
                        </button>
                    ) : null}
                </div>

                {includeDates ? (
                    <div onClick={setDateRange}>
                        <Datepicker
                            model={`${model}.startDate`}
                            id="search-date-from"
                            title="From"
                            isClearable={true}
                        />

                        <Datepicker
                            model={`${model}.endDate`}
                            id="search-date-to"
                            title="To"
                            isClearable={true}
                            minDate={fromDate}
                        />
                    </div>
                ) : null}

                <Accordion
                    data={makeSearchData(
                        model,
                        updateDistrict,
                        updateRS,
                        updateRssOss,
                        updateRssOssType,
                        regionCodeList,
                        districtCodeList,
                        recruitingStationCodeList,
                        rssOssCodeList
                    )}
                />

                <div className="form__row">
                    <button className="form__submit" type="submit">
                        Apply
                    </button>
                    <button
                        type="button"
                        className="btn btn--reset"
                        onClick={resetSearchBtn}
                    >
                        Reset
                    </button>
                </div>
            </div>
        </section>
    )
);



// WEBPACK FOOTER //
// ./src/components/filters/index.js